import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from 'src/app/shared/global-constants';
import {CommonService} from 'src/app/shared/common.service';
import {UserAuthoritiesService} from 'src/app/shared/user/user-authorities.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutConfirmService {

  config = JSON.parse(this.service.decrypt(localStorage.getItem(GlobalConstants.LMS_CONFIG)));
  constructor(
    private readonly http: HttpClient,
    private readonly service: CommonService,
    private readonly userAuthoritiesService: UserAuthoritiesService,
  ) {}

  logout(): Observable<any> {
    this.userAuthoritiesService.clearCache();
    return this.http.get(
      `${environment.v2ApiBaseUrl}user_authentication/logout`
    );
  }

  deleteUserDetails(key: any): Observable<any>{
    const url = `${environment.baseUrl}${environment.deleteUserDetails}?key=${key}`;
    return this.http.delete(url);
  }

}
